import { FormSkeleton } from "@components/common/skeletons";
import { TicketForm } from "@features/tickets/components/form/TicketForm";
import { ROUTES } from "@features/tickets/config/constants";
import { useTicket } from "@features/tickets/hooks/useTickets";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, useNavigate, useParams } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/tickets/$id/edit")({
  loader: requirePermission(PERMISSIONS.TICKETS.TICKETS.EDIT),
  staticData: {
    title: "Modifier le ticket",
    showInBreadcrumb: true,
    showInTab: false,
  },
  component: TicketEditPage,
});

function TicketEditPage() {
  const { id } = useParams({ from: "/_app/tickets/$id/edit" });
  const navigate = useNavigate();
  const { data: ticket, isLoading, error } = useTicket(id);

  if (isLoading) {
    return (
      <div className="max-w-4xl mx-auto">
        <FormSkeleton fields={4} hasSubmitButton />
      </div>
    );
  }

  if (error || !ticket) {
    return (
      <div className="flex flex-col items-center justify-center py-20 gap-4">
        <p className="text-base-content/60">Ticket introuvable.</p>
        <button
          className="btn btn-outline btn-sm"
          onClick={() => navigate({ to: ROUTES.TICKETS.LIST })}
        >
          Retour à la liste
        </button>
      </div>
    );
  }

  return (
    <TicketForm
      mode="edit"
      initialData={{
        id: ticket.id,
        title: ticket.title,
        description: ticket.description,
        category: ticket.category,
        routeEntries: [
          {
            route: ticket.context?.affected_routes?.[0]?.route ?? "",
            routeTitle: ticket.context?.affected_routes?.[0]?.route_title ?? "",
            apiEndpoint: "",
            errorMessage: "",
          },
        ],
        attachments: [],
      }}
      onSuccess={() => navigate({ to: ROUTES.TICKETS.LIST })}
    />
  );
}
